import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { constants, isNotEmpty } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import PerfumeCaseVolume from './PerfumeCaseVolume/PerfumeCaseVolume'
import DefaultExtraVolume from './DefaultExtraVolume/DefaultExtraVolume'
import DefaultVolume from './DefaultVolume/DefaultVolume'

import messages from './messages'
import s from './ProductVolumes.scss'


const { productTypeGroups: typeGroups } = constants

const ProductVolumes = (props) => {
  const { className, items, activeItem: { id: activeItemId, colorName, actualType } = {}, brand, onSelect, withMicrodata } = props
  const isExtra            = [ typeGroups.perfumeCase, typeGroups.candleSet, typeGroups.fragranceStorageBox ].indexOf(actualType) > -1
  const isDefaultExtra     = [ typeGroups.candleSet, typeGroups.fragranceStorageBox ].indexOf(actualType) > -1
  const isPerfumeCaseExtra = actualType === typeGroups.perfumeCase

  const volumesClassName = cx(s.volumes, {
    [s.perfumeCaseVolumes]: isPerfumeCaseExtra,
  })

  return isNotEmpty(items) && (
    <div className={className}>
      {
        Boolean(colorName) && <FormattedHTMLMessage className={s.color} {...messages.color} values={{ colorName }} />
      }
      <div className={volumesClassName}>
        {
          items.map((item, index) => {
            const { id } = item

            const isActive = activeItemId === id

            const testId = (index > 0 || isExtra)
              ? constants.testIds.common.productVolumes.addToCartBtn
              : constants.testIds.common.productVolumes.addToQueueBtn

            const volumeProps = {
              key: id,
              className: s.volume,
              item,
              index,
              isActive,
              brand,
              onSelect,
              withMicrodata,
              testId,
            }

            if (isPerfumeCaseExtra) {
              return <PerfumeCaseVolume {...volumeProps} />
            }

            if (isDefaultExtra) {
              return <DefaultExtraVolume {...volumeProps} />
            }

            return <DefaultVolume {...volumeProps} />
          })
        }
      </div>
    </div>
  )
}

ProductVolumes.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array,
  activeItem: PropTypes.shape({
    id: PropTypes.number,
    colorName: PropTypes.string,
    actualType: PropTypes.string,
  }),
  brand: PropTypes.string,
  onSelect: PropTypes.func,
  withMicrodata: PropTypes.bool,
}


export default ProductVolumes
